import { DeveloperPermissionItem } from '../../PermissionItem'

const allowMixedCase = true

export const CreateAPIKey = new DeveloperPermissionItem({
  id: 'ab91d78d-15c9-46c0-b88e-0e24d3e7eb10',
  name: 'Create API Key',
  action: 'create API keys',
  allowMixedCase,
})

export const RemoveAPIKey = new DeveloperPermissionItem({
  id: '554a9e21-fbf4-49a8-9312-2559c867f67f',
  name: 'Remove API Key',
  action: 'remove API keys',
  allowMixedCase,
})

export const ViewAPIKey = new DeveloperPermissionItem({
  id: '5451ce7b-d5a9-4afc-b7cb-17d3db70e8f5',
  name: 'View API Key',
  action: 'view API keys',
  allowMixedCase,
})

export const AssociateProjectWithCIMS = new DeveloperPermissionItem({
  id: '35554919-7a23-4541-8138-9d2229be8a06',
  name: 'Associate Project with CIMS',
  action: 'associate a project with CIMS',
  allowMixedCase,
})

export const SyncUsers = new DeveloperPermissionItem({
  id: '07d4dec4-262b-4b9d-8a2d-1d01ff39dcf8',
  name: 'Sync Users',
  action: 'sync users',
})

export const EditRFIResponse = new DeveloperPermissionItem({
  id: '79426dac-d05d-4e49-a2d7-7f4cbe66bbe2',
  name: 'Edit RFI Response',
  action: 'edit RFI responses',
})

export const RefreshRedisCache = new DeveloperPermissionItem({
  id: '38e91f3e-5bdd-457b-8907-65f456e1fae4',
  name: 'Refresh Redis Cache',
  action: 'manually clear items from the Redis Cache',
})

export type DeveloperPermission =
  | typeof CreateAPIKey
  | typeof RemoveAPIKey
  | typeof ViewAPIKey
  | typeof AssociateProjectWithCIMS
  | typeof SyncUsers
  | typeof EditRFIResponse
  | typeof RefreshRedisCache
